import { apiConfig } from '../config/api';

/**
 * Turn a stored profile image path or URL into a browser-loadable src.
 * Absolute http(s) and data URLs are returned as-is (Google avatars, etc.).
 */
export function resolveDisplayProfilePhotoUrl(raw?: string | null): string | undefined {
  if (!raw) return undefined;
  const url = raw.trim();
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url) || url.startsWith('data:')) {
    return url;
  }

  const baseUrl = apiConfig.getBaseUrl().replace(/\/$/, '');

  if (url.startsWith('/uploads/profiles/') || url.startsWith('uploads/profiles/')) {
    const filename = url.split('/').pop();
    return filename ? `${baseUrl}/api/UserProfile/image/${filename}` : undefined;
  }

  if (url.startsWith('/')) {
    return `${baseUrl}${url}`;
  }

  return `${baseUrl}/${url}`;
}
